import { Mark } from 'tiptap'
import { toggleMark } from 'prosemirror-commands'

export default class HighlightMarkBlue extends Mark {
    get name () {
        return 'highlight_mark_blue'
    }

    get schema () {
        return {
            attrs: {
                color: {
                    default: 'rgba(0, 112, 185, 1)',
                }
            },
            parseDOM: [
                {
                    style: 'color',
                    getAttrs (value) {
                        return { color: value }
                    }
                }
            ],
            toDOM (mark) {
                let { color } = mark.attrs
                return ['span', { style: `color: ${color}` }, 0]
            }
        };
    }

    commands ({ type }) {
        return attrs => toggleMark(type, attrs)
    }
}
